import React from "react";

export const MainCopy = () => (
  <p>A profile picture greatly increases the visibility of your profile.</p>
);
